var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMachineControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 19.2,
    height: 18.7,
    viewBox: "0 0 19.2 18.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke-width:1.5;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    stroke: "currentColor",
    d: "M12.3,12.8L12.3,12.8l1.4,3.6c0.3,0.7-0.2,1.5-1,1.5H2.4c-0.8,0-1.3-0.8-1-1.5l1.4-3.6h0 M16.2,6.3h2.3V0.8 h-2.3V6.3z M14.6,5.9h-3.1 M7.5,4.1C5.4,4.1,3.7,5.8,3.7,8s1.7,3.9,3.9,3.9c1.1,0,2.1-0.5,2.8-1.3 M16.2,1.2H7.5 c-3.8,0-6.8,3-6.8,6.8c0,1.9,0.8,3.6,2,4.8c1.2,1.2,2.9,2,4.8,2c1.9,0,3.5-0.7,4.8-2c1.2-1.2,2-2.9,2-4.8c0-0.7-0.2-1.5-0.5-2.1h2.3 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineControl);
export default __webpack_public_path__ + "static/media/machine-control.7b4f690a3fd9b99af7c6a5563d9a7574.svg";
export { ForwardRef as ReactComponent };